/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import { grey } from '@mui/material/colors'

import React, { RefObject } from 'react'

interface PropsType extends React.HTMLAttributes<HTMLButtonElement> {
	className?: string
	style?: React.CSSProperties
	children?: React.ReactNode
	disabled?: boolean
	ref?: RefObject<any>
	type?: 'button' | 'submit'
}

const ButtonComponent = styled.button({}, (props: PropsType) => {
	return { ...props.style }
})

export const Pressable = (props: PropsType) => {
	return (
		<ButtonComponent
			{...props}
			css={[style, props.disabled ? { opacity: 0.3 } : null]}
			disabled={props.disabled ?? false}
			type={props.type ?? 'button'}
		>
			{props.children}
		</ButtonComponent>
	)
}

const style = css({
	backgroundColor: 'rgba(255, 255, 255, 0)',
	border: 0,
	cursor: 'pointer',
	color: grey[900],
})
